import { useState, useEffect, useRef, forwardRef, useImperativeHandle, memo, createRef } from 'react';
import Button from '@mui/material/Button';
import {
    Box,
    Grid2 as Grid,
    DialogTitle,
    Tooltip,
    ButtonGroup,
    Chip,
    Input,
    Typography,
    useMediaQuery,
    IconButton
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import _ from 'lodash';

import { globalstyles } from '../lib/definitions';
import { checkComponentPresence, getSelectedElement, myTimestampToDate, propComparator, propComparatorDate } from '../utils/ui_utils';
import { format } from 'date-fns';
import { Backspace, Block, BorderRight, Check, CheckBox, CheckBoxOutlineBlank, Close, Error, Info, List, MilitaryTech, PictureAsPdf, PlayArrow, Save, Stop, Warning } from '@mui/icons-material';
import { SideBadge } from '../components/SideBadge';
import DeleteconfirmationSection from '../components/DeleteConfirmationSection';
import { useEvent } from '../context/eventContext';
import { MatchDocumentsDialog } from './MatchDocumentsDialog';
import { set_event_status } from '../FirebaseUtils/dbEvent';
import MultiColorProgressBar from '../components/MultiColorProgressBar';
import { PresenceButton } from '../components/PresenceButton';
import { getCowLight } from '../definitions/cow';
import { PublicCowDialog } from './PublicCowDialog';
import { CowtypeBadge } from '../components/CowtypeButton';
import { initCowlist } from '../definitions/match';
import { PrematchCowlist, PrematchCowlistHeader } from '../components/PrematchCowlist';
import { get_Cow_byID } from '../FirebaseUtils/dbCow';
import { MyBadge } from '../components/graphicElements';
import { AwardListPointDialog } from './AwardListPointDialog';
import MatchresultMenu from '../components/menu/MatchResultMenu';


const newposition = {
    position_label: '',
    position_id: 0,
}


const match_status_list = [
    { id: 'pre', label: 'pregara', color: 'primary' },
    { id: 'run', label: 'gara in corso', color: 'success' },
    { id: 'end', label: 'gara terminata', color: 'error' },
]


const status_index = {
    'pre': 0,
    'run': 1,
    'end': 2
}


export const MatchResultDialog = forwardRef(({ editFn, event_status, handleDoSplit }, ref) => {
    const childRefDelete = useRef()
    const awardListRef = useRef()
    const publicRef = useRef()
    const documentRef = useRef()
    const { selEvent } = useEvent()
    const [open, setOpen] = useState(false);
    const [isEdited, setIsEdited] = useState(false)
    const [award_list, setAwardList] = useState([])
    const [cur_match, setCurMatch] = useState({})
    const [selected_cow_id, setSelectedCow] = useState([])
    const [index, setIndex] = useState(-1)
    const [curAwardIndex, setCurAwardIndex] = useState([])
    const [matchStatus, setMatchStatus] = useState('pre')
    const [viewStatus, setViewStatus] = useState('pre')
    const [insertMode, setInsertMode] = useState('text')
    const [viewMode, setViewMode] = useState('simple')
    const [duplicated_value, setDuplicatedValue] = useState([])
    const [c_height, setContentHeight] = useState('70vh')
    const [not_completed, setNotCompleted] = useState(0)
    const [confirmMode, setConfirmMode] = useState('dynamic')
    const [dynamic_cow_list, setDynamicCowList] = useState([])
    const [linked_cow_list, setLinkedCowList] = useState([])
    const [manual_cow_list, setManualCowList] = useState([])
    //    const [showSourceList, setShowSourceList] = useState(true)
    //    const [selected_source_cow_id, setSelectedSourceCow] = useState([])
    const matchCssSize = useMediaQuery('(min-width:1080px)');

    const contentRef = createRef()
    useImperativeHandle(ref, () => {
        return {
            onOpen(el, i, m_list, category_cow_list) {
                console.log("DO OPEN", el)
                setOpen(true);
                initData(el, m_list, category_cow_list)
                setCurMatch(el)
                setSelectedCow([])
                if (el.result_list) {
                    setCurAwardIndex(el.award_list.map(a => ({
                        id: a.id,
                        cur_id: 0,
                        selected_cow: -1,
                        from_other_data: a.from_other_data,
                        has_position: a.has_position,
                        award_value: a.award_value,
                        max_position: a.has_position ? el.cow_list.filter(c => c.is_in_ring === true).length : 1
                    })))
                    setContentHeight('70vh')
                } else {
                    setCurAwardIndex([])
                }
                setAwardList(el.result_list || [])
                setMatchStatus(el.status || 'pre')
                setViewStatus(el.status || 'pre')
                //               if (el.status === undefined) {
                //setShowSourceList(true)
                //}
                setIndex(i)
                setIsEdited(false)
                setDuplicatedValue([])
            },

        }
    })


    const handleClose = () => {
        setOpen(false);
    };


    const toggleInsertMode = () => {
        setInsertMode(t => {
            if (t === 'button') {
                return 'text'
            } else {
                return 'button'
            }
        })
    }

    const toggleSelect = (cow_id) => {
        setSelectedCow(c => {
            let _c = [...c]
            const k = _c.indexOf(cow_id)
            if (k < 0) {
                _c.push(cow_id)
            } else {
                _c.splice(k, 1)
            }
            return _c
        })
    }

    useEffect(() => {
        if (matchStatus === 'run') {
            const cow_results = cur_match.cow_list.map(c => c.award_dict).filter(e => e !== undefined && Object.keys(e).length > 0)
            const res_map = cow_results.map(e => Object.entries(e).filter(c => c[1].position >= 0).map(c => `${c[0]}_${c[1].position}`))
            const array = res_map.flat(1)
            const duplicates = array.filter((item, index) => array.indexOf(item) !== index);
            setDuplicatedValue(duplicates)

        }

    }, [cur_match])



    const handleAddCowList = (cl) => {
        console.log("MANUAL ADD", cl)
        setManualCowList(m => [...m, ...cl.map(c => ({ ...c, from_manual: true, is_in_ring: true, is_present: true }))])
        if (cur_match.cow_list && cur_match.cow_list.length > 0) {
            setCurMatch(m => {
                return { ...m, cow_list: [...m.cow_list, ...cl.map(c => ({ ...c, from_manual: true, is_in_ring: true, is_present: true }))] }
            })
        }
    }


    const handleRemoveCow = (cow) => {
        console.log("MANUAL REMOVE", cow.id)
        setManualCowList(m => {
            let _m = [...m]
            const c = checkComponentPresence(cow, m, 'id')
            if (c >= 0) {
                _m.splice(c, 1)

            }
            return _m
        })
        if (cur_match.cow_list && cur_match.cow_list.length > 0) {
            setCurMatch(m => {
                let _m = { ...m }
                let _c_list = [...m.cow_list]
                const c = checkComponentPresence(cow, m, 'id')
                if (c >= 0) {
                    _c_list.splice(c, 1)
                }
                return { ..._m, cow_list: _c_list }
            })
        }

    }


    const updateCowParam = (index, param, value) => {
        console.log(">>CLICK", index, param)
        let other_cow_params = cur_match.award_list.filter(a => a.from_other_data).map(a => a.award_value)
        if (selEvent.custom_cow_filter_param_list) {
            other_cow_params = [...other_cow_params, ...selEvent.custom_cow_filter_param_list.map(p => p.param_name)]
        }
        if (viewStatus === 'pre') {
            setCurMatch(m => {
                let _cow_list = []
                if (m.cow_list.length > 0) {
                    _cow_list = [...m.cow_list]
                } else {
                    if (linked_cow_list.length > 0) {
                        _cow_list = [...linked_cow_list.filter(c => c.is_present === true).map(c => ({ ...c, is_in_ring: true }))]
                    }
                    if (dynamic_cow_list.length > 0) {
                        _cow_list = [...dynamic_cow_list.filter(c => c.is_present === true).map(c => ({ ...c, is_in_ring: true }))]
                    }
                    if (manual_cow_list.length > 0) {
                        _cow_list = [..._cow_list, ...manual_cow_list.map(c => ({ ...c, is_in_ring: true, from_manual: true, is_present: true }))]
                    }
                }
                _cow_list.splice(index, 1, { ..._cow_list[index], [param]: value })
                return { ...m, cow_list: _cow_list }
            })
        } else if (viewStatus === 'run') {
            if (insertMode === 'button' || !award_list[index].has_position) {
                //BUTTON OR NOT POSITION
                setCurMatch(m => {
                    let _cow_list = [...m.cow_list]
                    const oc = findOtherSameAward(m.cow_list, cur_match.id + "_" + award_list[index].id, curAwardIndex[index].cur_id)
                    if (award_list[index].id, curAwardIndex[index].cur_id >= 0 && oc >= 0) {
                        const oldcow = { ...m.cow_list[oc] }
                        let award_dict = {}
                        if (oldcow.award_dict) {
                            award_dict = { ...oldcow.award_dict }
                        }
                        delete award_dict[cur_match.id + "_" + award_list[index].id]
                        oldcow.award_dict = award_dict
                        _cow_list.splice(oc, 1, { ..._cow_list[oc], award_dict: award_dict })
                    }
                    console.log("SAME AWARD", curAwardIndex[index].cur_id, oc)
                    const c = checkComponentPresence(param, m.cow_list, 'id')
                    const realcow = { ...m.cow_list[c] }
                    let award_dict = {}
                    if (realcow.award_dict) {
                        award_dict = { ...realcow.award_dict }
                    }
                    award_dict[cur_match.id + "_" + award_list[index].id] = { position: curAwardIndex[index].cur_id, match_name: cur_match.match_name }
                    realcow.award_dict = award_dict
                    _cow_list.splice(c, 1, { ..._cow_list[c], award_dict: award_dict })
                    return { ...m, cow_list: _cow_list }
                })
                setAwardList(al => {
                    let _al = [...al]
                    let _sel_al = { ...al[index] }
                    let _c_list = [..._sel_al.cow_list]
                    const c = checkComponentPresence(param, _c_list.map(c => c.cow || {}), 'id')
                    if (c >= 0) {
                        _c_list.splice(c, 1, { ..._c_list[c], cow: {} })
                    }
                    if (curAwardIndex[index].cur_id >= 0) {

                        _c_list.splice([curAwardIndex[index].cur_id], 1, { ..._c_list[curAwardIndex[index].cur_id], cow: getCowLight(param, other_cow_params) })
                        _al.splice(index, 1, { ..._sel_al, cow_list: _c_list })
                    }
                    console.log("ASSIGN", c, _al)
                    //                setCurAwardIndex([index, curAwardIndex[1] + 1])
                    return _al
                })
                if (curAwardIndex[index].has_position && curAwardIndex[index].cur_id >= 0 && curAwardIndex[index].cur_id < award_list[index].cow_list.length - 1) {
                    setCurAwardIndex(ai => {
                        let _ai = [...ai]
                        console.log("---INCREMENT CUR", ai[index].cur_id)
                        _ai.splice(index, 1, { ...ai[index], cur_id: ai[index].cur_id + 1 })
                        return _ai
                    })
                }

            } else {
                //TEXT MODE
                console.log("PARAM; INDEX", param, index, value)
                setCurMatch(m => {
                    let _cow_list = [...m.cow_list]
                    const c = checkComponentPresence(param, m.cow_list, 'id')
                    const realcow = { ...m.cow_list[c] }
                    let award_dict = {}
                    if (realcow.award_dict) {
                        award_dict = { ...realcow.award_dict }
                    }
                    award_dict[cur_match.id + "_" + award_list[index].id] = { position: value, match_name: cur_match.match_name }
                    realcow.award_dict = award_dict
                    const award = award_list[index]
                    _cow_list.splice(c, 1, { ..._cow_list[c], award_dict: award_dict })
                    const cow_results = _cow_list.filter(c => c.award_dict && c.award_dict[cur_match.id + "_" + award.id]).map(c => ({ ...c, position: c.award_dict[cur_match.id + "_" + award.id].position }))
                    setAwardList(al => {
                        let _al = [...al]
                        let _sel_al = { ...al[index] }
                        let _c_list = [..._sel_al.cow_list]
                        console.log(_sel_al.cow_list)
                        for (let c of _sel_al.cow_list) {
                            if (c.position_id >= 0) {
                                const _cc = getCowLight(getSelectedElement(c.position_id, cow_results, 'position'), other_cow_params)
                                if (_cc.id) {
                                    c.cow = _cc
                                } else {
                                    c.cow = {}
                                }
                            } else {
                                c.cow = {}
                            }
                        }
                        _al.splice(index, 1, { ..._sel_al, cow_list: _c_list })
                        return _al
                    })
                    return { ...m, cow_list: _cow_list }
                })
                /*                 setAwardList(al => {
                                    let _al = [...al]
                                    let _sel_al = { ...al[index] }
                                    console.log("AL, COW LIST", _sel_al.cow_list)
                                    let _c_list = []
                                    if (_sel_al.cow_list) {
                                        _c_list = [..._sel_al.cow_list]
                                    }
                
                                    const c = checkComponentPresence(param, _c_list.map(c => c.cow || {}), 'id')
                                    console.log("INSERT SPLICE", c, value)
                
                                    if (c >= 0) {
                                        _c_list.splice(c, 1, { ..._c_list[c], cow: {} })
                                    }
                                    if (value>=0 && value < _c_list.length ) {
                                        _c_list.splice(value, 1, { ..._c_list[value], cow: getCowLight(param) })
                                    }
                                    if (value < _c_list.length || isNaN(value)) {
                                        _al.splice(index, 1, { ..._sel_al, cow_list: _c_list })
                                    }
                                    console.log("ASSIGN", c, _al)
                                    //                setCurAwardIndex([index, curAwardIndex[1] + 1])
                                    return _al
                                }) */
            }

        } else if (viewStatus === 'end') {
            console.log("---------------------UPDATE END COW PARAM-----------------------")
            const new_value = !cur_match.cow_list[index][param]
            let _cow_list = [...cur_match.cow_list]
            _cow_list.splice(index, 1, { ..._cow_list[index], [param]: new_value })
            let _al = []
            for (const _sel_al of award_list) {
                let _c_list = [..._sel_al.cow_list]
                const c = checkComponentPresence(cur_match.cow_list[index], _c_list.map(c => c.cow || {}), 'id')
                console.log("UPDATE COW", c, _c_list[c].cow, new_value)
                if (c >= 0) {
                    _c_list.splice(c, 1, { ..._c_list[c], cow: { ..._c_list[c].cow, [param]: new_value } })
                }
                _sel_al.cow_list = _c_list
                _al.push(_sel_al)
            }
            const _m = validateFinalResult({ ...cur_match, cow_list: _cow_list }, award_list)
            setCurMatch(_m)
            setAwardList(_al)
        }
        setIsEdited(true)

    }
    const getRealCow = async (c) => {
        //console.log(c)
        const res = await get_Cow_byID(selEvent.id, c.id)
        console.log("COW GET ID", res)
        return res
    }

    const initRealCowList = async (cl) => {
        let _cl = []
        console.log("CL", cl)
        for (const c of cl) {
            if (c.award_dict) {
                let _a_dict = { ...c.award_dict }
                for (const a of award_list) {
                    delete _a_dict[cur_match.id + "_" + a.id]
                }
                const d = await getRealCow(c)
                _cl.push({ ...c, ...d, award_dict: _a_dict })
                console.log("::::D", d)
            } else {
                _cl.push(c)
                //                return c
            }
        }
        //console.log(Promise.all(_cl))
        return _cl
    }

    const handleStep = async (s) => {
        if (s === 'pre') {
            const cb = async () => {
                let _cow_list = await initRealCowList(cur_match.cow_list)
                let _m = { ...cur_match }
                delete _m.real_start
                delete _m.real_end
                _m.status = 'pre'
                _m.cow_list = _cow_list
                setCurMatch({
                    ..._m,
                    //    cow_list: _cow_list
                })
                editFn(_m, index)
                /*
            setCurMatch( async m => {
                let _m = { ...m }
                delete _m.real_start
                delete _m.real_end
                _m.status = 'pre'
                console.log(":::::::", _m)
                 _m.cow_list = await initCowList(_m.cow_list.map(async c => {
                    if (c.award_dict) {
                        let _a_dict = { ...c.award_dict }
                        for (const a of award_list) {
                            //console.log("AWARD", a)
                            delete _a_dict[cur_match.id + "_" + a.id]
                        }
                        return { ...c, ...await getRealCow(c), award_dict: _a_dict }
                    } else {
                        return c
                    }
                }))//.sort(propComparatorDate('birthdate', true, 'catalog_id')) 
                console.log("NEW COW LIST", m.cow_list)
                editFn(_m, index)
                return _m
            })
                */
                setViewStatus(s)
                setMatchStatus(s)
                setIsEdited(false)
                setAwardList([])
                setCurAwardIndex([])
            }
            childRefDelete.current.confirmDelete('Annulla inizio gara', `Sei sicuro di voler annullare l'inizio della gara? Eventuali dati di gara e posizioni assegnate verranno eliminate`, cb)
        } else if (s === 'prerun') {
            const cb = async () => {
                let _cow_list = []
                if (linked_cow_list.length > 0) {
                    _cow_list = await Promise.all([...linked_cow_list.filter(c => c.is_present === true).map(async c => ({ ...c, ...await getRealCow(c), is_in_ring: true }))])
                }
                if (dynamic_cow_list.length > 0) {
                    _cow_list = await Promise.all([...dynamic_cow_list.filter(c => c.is_present === true).map(async c => ({ ...c, ...await getRealCow(c), is_in_ring: true }))])
                }
                if (manual_cow_list.length > 0) {
                    _cow_list = await Promise.all([..._cow_list, ...manual_cow_list.map(async c => ({ ...c, ...await getRealCow(c), is_in_ring: true, from_manual: true, is_present: true }))])
                }
                _cow_list = await initRealCowList(_cow_list)
                if (award_list.length === 0) {
                    _cow_list = initAwardList(_cow_list)
                }
                //_cow_list = _cow_list.sort(propComparatorDate('birthdate', true, 'catalog_id'))
                setCurMatch({ ...cur_match, cow_list: _cow_list, real_start: new Date(), status: 'run' })
                editFn({ ...cur_match, cow_list: _cow_list, real_start: new Date(), status: 'run' }, index)
                setViewStatus('run')
                setMatchStatus('run')
                setIsEdited(false)
            }
            cb()

        } else if (s === 'run') {
            const cb = () => {
                if (award_list.length === 0) {
                    initAwardList()
                }
                setCurMatch(m => ({ ...m, real_start: new Date(), status: 'run' }))
                editFn({ ...cur_match, real_start: new Date(), status: 'run' }, index)
                setViewStatus(s)
                setMatchStatus(s)
                setIsEdited(false)
            }
            if (cur_match.cow_list?.filter(c => c.is_in_ring).length === 0) {
                childRefDelete.current.confirmDelete('Gara con 0 soggetti', `Sei sicuro di voler avviare questa gara con ZERO soggetti?`, cb)
            } else {
                cb()
            }
        } else if (s === 'end') {
            const _m = validateFinalResult(cur_match, award_list)
            setCurMatch(m => ({ ..._m, real_end: new Date(), status: 'end' }))
            editFn({ ..._m, real_end: new Date(), status: 'end', result_list: award_list }, index)
            setViewStatus(s)
            setMatchStatus(s)
            setIsEdited(false)
        }
    }

    const squalifyCow = (cow, index, v) => {
        const param = 'squalified'
        const new_value = v
        let _cow_list = [...cur_match.cow_list]
        const old_results = award_list.map(a => {
            let _a = { ...a }
            _a.cow_list = _a.cow_list.map(c => { return { ...c } })
            return _a
        })
        const old_cowlist = _cow_list.map(c => {
            let _c = { ...c }
            _c.award_dict = { ..._c.award_dict }
            return _c
        })
        let _al = [...award_list]


        if (v === true) {
            _cow_list.splice(index, 1, { ..._cow_list[index], [param]: new_value })
            console.log("ORIGINAL RESULT LIST", old_results)
            _al = []
            for (const _sel_al of award_list) {
                let _c_list = [..._sel_al.cow_list]
                let shift_pos = false
                let shift_cow = undefined
                let original_position = -1
                const aw_id = cur_match.id + "_" + _sel_al.id
                let new_c_list = []
                for (const c_pos in _c_list) {
                    console.log("CHECK....", c_pos, _c_list[c_pos], cow.id)
                    if (_c_list[c_pos].cow && _c_list[c_pos].cow.id === cow.id) {
                        console.log("FOUNDsqualified")
                        shift_pos = true
                        shift_cow = { ..._c_list[c_pos].cow }
                        original_position = _c_list[c_pos].position_id
                        shift_cow.squalified = true
                    }
                    if (shift_pos) {
                        let cur_aw_cow = { ..._c_list[c_pos] }
                        const next_c_pos = parseInt(c_pos) + 1
                        console.log("SHIFT OTHER COW", c_pos, c_pos + 1, _c_list[next_c_pos])
                        let c_index = -1
                        if (_c_list[next_c_pos]) {
                            cur_aw_cow.cow = _c_list[next_c_pos].cow
                            c_index = _cow_list.map(c => c.id).indexOf(_c_list[next_c_pos].cow.id)
                        } else {
                            cur_aw_cow.cow = shift_cow
                            cur_aw_cow.original_position_id = original_position
                            cur_aw_cow.position_id = -1
                            c_index = _cow_list.map(c => c.id).indexOf(shift_cow.id)
                        }
                        if (c_index >= 0) {
                            let a_cow = _cow_list[c_index]
                            let _award_dict = {}
                            if (a_cow.award_dict) {
                                _award_dict = a_cow.award_dict
                            }
                            _award_dict[aw_id].position = c_pos
                            a_cow.award_dict = _award_dict
                            _cow_list.splice(c_index, 1, a_cow)
                        }
                        new_c_list.push(cur_aw_cow)
                    } else {
                        new_c_list.push({ ..._c_list[c_pos] })
                        console.log("KEEP", c_pos)
                    }
                }
                _sel_al.cow_list = new_c_list
                _al.push(_sel_al)
            }
            console.log("SQUALIFIED RESULT LIST", _al)
        }
        if (v === false) {
            console.log("RESTORE POSITION")
            _al = [...cur_match.original_result_list]
            _cow_list = [...cur_match.original_cow_list]
        }

        let _m = validateFinalResult({ ...cur_match, cow_list: _cow_list }, _al)
        if (v === true && !cur_match.original_result_list) {
            _m.original_result_list = old_results
            _m.original_cow_list = old_cowlist
        }
        setCurMatch(_m)
        setAwardList(_al)
        setIsEdited(true)
    }


    const testFn = () => {
        //        initAwardList()

        //const match = validateFinalResult(cur_match, award_list, true)
        //setCurMatch(match)
        //editFn(match)
        correctOrder()
        //console.log("MATCH", match)
    }

    const handleSave = () => {
        console.log("MATCH_STATUS", matchStatus)
        setIsEdited(false)
        if (matchStatus === 'pre') {
            editFn({ ...cur_match, status: 'pre' }, index)
        } else if (matchStatus === 'run' || matchStatus === 'end') {
            //            validateFinalResult(cur_match, award_list)
            editFn({ ...validateFinalResult(cur_match, award_list), status: 'run', result_list: award_list }, index)
        }
    }

    const initAwardList = (cl) => {
        let cow_list = cl || cur_match.cow_list
        console.log("initAwardList", cl, cur_match.cow_list)
        setContentHeight(contentRef.current?.clientHeight - 30)
        let other_cow_params = cur_match.award_list.filter(a => a.from_other_data).map(a => a.award_value)
        if (selEvent.custom_cow_filter_param_list) {
            other_cow_params = [...other_cow_params, ...selEvent.custom_cow_filter_param_list.map(p => p.param_name)]
        }
        console.log("INIT AWARD FILTETR", other_cow_params)
        let al = cur_match.award_list.map(a => {
            let cl = [{ ...newposition, position_id: 0 }]
            if (a.from_other_data) {
                console.log(cow_list?.filter(c => c.is_in_ring === true))
                cl = cow_list?.filter(c => c.is_in_ring === true).sort(propComparator(a.award_value))
                cl.reverse()
                cl = cl.map((c, k) => {
                    console.log(a.award_value, c[a.award_value], c)
                    return { ...newposition, position_id: c[a.award_value] !== undefined ? k : -1, cow: getCowLight(c, other_cow_params) }
                })
                console.log("cow award sort", cl)
            } else {
                if (a.has_position) {
                    cl = cow_list?.filter(c => c.is_in_ring === true).map((c, k) => ({ ...newposition, position_id: k }))
                } else {
                    cl = [{ ...newposition, position_id: 0 }]
                }
            }
            return {
                ...a,
                cow_list: cl
            }
        })
        setAwardList(al)
        setCurAwardIndex(cur_match.award_list.map(a => (
            {
                id: a.id,
                cur_id: 0,
                selected_cow: -1,
                from_other_data: a.from_other_data,
                award_value: a.award_value,
                has_position: a.has_position,
                max_position: a.has_position ? cow_list.filter(c => c.is_in_ring === true).length : 1
            })))
        setIsEdited(false)
        console.log("init award list", al)
        let _cl = cow_list
        _cl = _cl.map((c => {
            let award_dict = {}
            if (c.award_dict) {
                award_dict = { ...c.award_dict }
            }
            for (const aw of al) {

                if (aw.from_other_data) {
                    //console.log("INIT award", aw.cow_list, c.id, aw.cow_list.map(cc => cc.cow?.id).indexOf(c.id))
                    const pos = aw.cow_list.map(cc => cc.cow?.id).indexOf(c.id)
                    if (aw.cow_list[pos]) {
                        console.log("INIT pos", aw.cow_list[pos], pos, aw.cow_list[pos].position_id >= 0)

                        award_dict[cur_match.id + "_" + aw.id] = {
                            position: aw.cow_list[pos].position_id >= 0 ? pos : -1,
                            award_name: aw.award_name,
                            match_name: cur_match.match_name
                        }
                    }
                }
            }
            console.log("cow award dict")
            return { ...c, award_dict: award_dict }
        }))
        console.log("MATCH COW LIST (with award dict)", _cl)
        if (!cl) {
            setCurMatch(cm => {
                return { ...cm, cow_list: _cl }
            })
        } else {
            return _cl
        }

    }

    const updateCurIndex = (a_index, index) => {
        console.log("update cur index", a_index, index)
        setCurAwardIndex(ai => {
            let _ai = [...ai]
            _ai.splice(a_index, 1, { ...ai[a_index], cur_id: index })
            return _ai
        })


    }

    const correctOrder = () => {
        let cl_list = []
        if (dynamic_cow_list && dynamic_cow_list.length > 0) {


            for (const c of dynamic_cow_list) {
                console.log(c.catalog_id)
                const _rea_c = getSelectedElement(c.id, cur_match.cow_list, 'id')
                console.log(_rea_c.catalog_id)
                if (_rea_c) {
                    cl_list.push(_rea_c)
                }
            }
            setCurMatch(m => ({ ...m, cow_list: cl_list }))
        }
    }


    const resetAward = (award, index) => {
        const cb = () => {

            console.log("AWARD DEL", award, index)
            setCurMatch(m => {
                let new_list = m.cow_list.map(cow => {
                    let _cow = { ...cow }
                    if (_cow.award_dict) {
                        let award_dict = { ...cow.award_dict }
                        delete award_dict[cur_match.id + "_" + award.id]
                        _cow.award_dict = award_dict
                    }
                    return _cow
                })
                return { ...m, cow_list: new_list }
            })
            setAwardList(al => {
                let _al = [...al]
                let _sel_al = { ...al[index] }
                let _c_list = award.has_position ? cur_match.cow_list.filter(c => c.is_in_ring === true).map((c, k) => ({ ...newposition, position_id: k })) : [{ ...newposition, position_id: 0 }]
                _al.splice(index, 1, { ..._sel_al, cow_list: _c_list })
                return _al
            })

            console.log(award.has_position, index, award.cow_list.length)
            if (award.has_position && index < award.cow_list.length) {
                setCurAwardIndex(ai => {
                    let _ai = [...ai]
                    _ai.splice(index, 1, { ...ai[index], cur_id: 0 })
                    return _ai
                })
            }
        }
        childRefDelete.current.confirmDelete('Cancella risultati', `Sei sicuro di voler cancellare i risultati per: <br/><b>${award.award_name}</b>`, cb)

    }

    const confirmAward = (award, index) => {
        console.log(award.id, cur_match.id)
        const cow_results = cur_match.cow_list.filter(c => c.award_dict && c.award_dict[cur_match.id + "_" + award.id]).map(c => ({ ...c, position: c.award_dict[cur_match.id + "_" + award.id].position }))
        console.log("COW RESULTS", cow_results)
        let other_cow_params = cur_match.award_list.filter(a => a.from_other_data).map(a => a.award_value)
        if (selEvent.custom_cow_filter_param_list) {
            other_cow_params = [...other_cow_params, ...selEvent.custom_cow_filter_param_list.map(p => p.param_name)]
        }
        setAwardList(al => {
            let _al = [...al]
            let _sel_al = { ...al[index] }
            let _c_list = [..._sel_al.cow_list]
            console.log(_sel_al.cow_list)
            for (let c of _sel_al.cow_list) {
                if (c.position_id >= 0) {
                    const _cc = getCowLight(getSelectedElement(c.position_id, cow_results, 'position'), other_cow_params)
                    if (_cc.id) {
                        c.cow = _cc
                    } else {
                        c.cow = {}
                    }
                }
            }
            console.log("INDEX", _c_list)
            _al.splice(index, 1, { ..._sel_al, cow_list: _c_list })
            return _al
        })
    }



    const showAwardList = () => {
        awardListRef.current.onEdit({ ...cur_match, result_list: award_list }, index)
    }


    const handleShow = (c) => {
        publicRef.current.onShow(c)
    }

    const initData = async (el, match_list, source_cow_list) => {
        const _data = initCowlist(el, match_list, source_cow_list)
        setConfirmMode(_data.confirm_mode)
        setNotCompleted(_data.not_completed)
        setLinkedCowList(_data.linked_cow_list.sort(propComparatorDate('birthdate', true, 'catalog_id')))
        //setSelectedSourceCow(_data.selected_source_cow)
        console.log("DATA", _data)
        setDynamicCowList(_data.dynamic_cow_list)
        //setShowSourceList(cur_match.cow_list === undefined || cur_match.cow_list.length === 0)

    }



    const doSplit = (ol, nl) => {
        handleClose()
        handleDoSplit(ol, nl)

    }


    const saveAs = () => {
        editFn(cur_match)
    }

    const Subheader = () => {
        if (viewStatus === 'pre') {
            console.log("PRE COW LIST", cur_match)
            return (
                <>
                    {matchStatus !== 'pre' &&
                        <><Button onClick={() => handleStep('pre')} variant="outlined" startIcon={<Backspace />} color="error">Annulla inizio gara</Button></>}
                    <PrematchCowlistHeader
                        dynamic_cow_list={dynamic_cow_list}
                        linked_cow_list={linked_cow_list}
                        cur_match={cur_match}
                        editFn={editFn}
                        doSplit={doSplit}
                        addCowList={handleAddCowList}
                    />
                </>
            )

        } else if (viewStatus === 'run') {
            return (
                <RunHeader award_list={award_list} resetAward={resetAward} cur_match={cur_match} viewMode={viewMode} />
            )
            /*             if (insertMode === 'button') {
                            return (
                                <RunHeader award_list={award_list} resetAward={resetAward} cur_match={cur_match}  viewMode={viewMode} />
                            )
            
                        } else {
                            const ConfirmBtn = ({ a, k }) => (
                                <Tooltip title="valida risultati inseriti a mano"  >
                                    <Button variant="contained" color="secondary" disabled={duplicated_value.length > 0} size="small" onClick={() => confirmAward(a, k)} startIcon={<Check />} ></Button>
                                </Tooltip>
                            )
                            return (
                                <RunHeader award_list={award_list} resetAward={resetAward} cur_match={cur_match} viewMode={viewMode}  />
                            )
            
                        } */

        } else {
            console.log("SUBHEADER-end", viewMode)
            return (
                <>
                    <RunHeader award_list={award_list} cur_match={cur_match} onlySource viewMode={viewMode} squalifyCow={squalifyCow} showUndo={cur_match.cow_list.filter(c => c.squalified).length > 0} />
                </>
            )

        }
    }

    const handlePdfDocs = () => {
        console.log("MATCH PDF", cur_match)
        documentRef.current.onOpen({
            ...cur_match,
            result_list: award_list,
            dynamic_cow_list: dynamic_cow_list?.filter(c => c.is_present === true),
            linked_cow_list: linked_cow_list
        })
    }
    const handlePlay = (c) => {
        if (c) {
            set_event_status(selEvent.id, {
                cur_match: {
                    match_name: cur_match.match_name,
                    match_description: cur_match.match_description,
                    id: cur_match.id,
                    award_label_list: cur_match.award_label_list || [],
                    award_list: cur_match.award_list || [],
                    result_list: cur_match.result_list || []
                }
            })

        } else {
            set_event_status(selEvent.id, {
                cur_match: {
                    match_name: '',
                    match_description: ''
                }
            })
        }

    }
    return (


        <Dialog open={open} onClose={handleClose} maxWidth="md" fullScreen={true} disableEscapeKeyDown>
            <DeleteconfirmationSection ref={childRefDelete} />
            <PublicCowDialog ref={publicRef} />
            <AwardListPointDialog ref={awardListRef} editFn={editFn} element_list={[]} />
            <MatchDocumentsDialog ref={documentRef} />
            <DialogTitle sx={{ p: 1 }}>
                <Grid container flexDirection={"column"}>
                    <Grid container alignItems={"center"} justifyContent={"space-around"} sx={{ pb: 0.5 }} spacing={1}>
                        <Grid >
                            Svolgimento Gara
                        </Grid>
                        <Grid size={"grow"} sx={{ backgroundColor: 'lavender', alignText: 'center' }}>
                            <Box sx={{ fontSize: '0.9em', color: 'blue' }}>{cur_match?.match_name}</Box>
                            <Box sx={{ fontSize: '0.7em' }}>{cur_match?.match_description}</Box>
                        </Grid>
                        <Grid size={"auto"}>
                            {(viewStatus === 'run' || viewStatus === 'end') &&
                                <MatchresultMenu insertMode={insertMode} setInsertMode={setInsertMode} viewMode={viewMode} setViewMode={setViewMode} correctOrder={correctOrder} saveAs={saveAs} />
                            }
                        </Grid>
                        {matchCssSize &&
                            <>
                                <Grid >
                                    <ButtonGroup>
                                        {match_status_list.map((s, k) => (
                                            <Button disabled={status_index[matchStatus] < status_index[s.id]} size="small" onClick={() => setViewStatus(s.id)} variant={s.id === viewStatus ? 'contained' : 'outlined'} color={s.color} startIcon={matchStatus === s.id ? <CheckBox /> : <></>}>{s.label}</Button>
                                        ))}
                                    </ButtonGroup>
                                </Grid>
                                <Grid sx={{ fontSize: '0.5em', textAlign: "center" }} size={1}>
                                    {cur_match.real_start && <> inizio gara: {format(myTimestampToDate(cur_match.real_start), 'HH:mm')}</>}<br />
                                    {cur_match.real_end && <> fine gara: {format(myTimestampToDate(cur_match.real_end), 'HH:mm')}</>}
                                </Grid>
                                <Grid sx={{ fontSize: '0.5em', textAlign: "center" }} size={1}>

                                    <ButtonGroup>
                                        <Tooltip title={`imposta su schermo esterno come gara in corso`}>
                                            <Button variant={event_status?.cur_match?.id === cur_match?.id ? 'contained' : "outlined"} color={'success'} size="small" onClick={() => handlePlay(true)} startIcon={<PlayArrow />}></Button>
                                        </Tooltip>
                                        <Tooltip title={`nascondi su schermo esterno`}>
                                            <Button variant={event_status?.cur_match?.id === cur_match?.id ? 'contained' : "outlined"} color={'primary'} size="small" onClick={() => handlePlay()} startIcon={<Stop />}></Button>
                                        </Tooltip>
                                    </ButtonGroup>
                                </Grid>
                            </>}
                    </Grid>
                    {!matchCssSize &&
                        <Grid container alignItems={"center"} justifyContent={"space-around"} sx={{ pb: 0.5 }} spacing={1}>
                            <Grid >
                                <ButtonGroup>
                                    {match_status_list.map((s, k) => (
                                        <Button disabled={status_index[matchStatus] < status_index[s.id]} size="small" onClick={() => setViewStatus(s.id)} variant={s.id === viewStatus ? 'contained' : 'outlined'} color={s.color} startIcon={matchStatus === s.id ? <CheckBox /> : <></>}>{s.label}</Button>
                                    ))}
                                </ButtonGroup>
                            </Grid>
                            <Grid sx={{ fontSize: '0.5em' }}>
                                {cur_match.real_start && <> inizio gara: {format(myTimestampToDate(cur_match.real_start), 'HH:mm')}</>}<br />
                                {cur_match.real_end && <> fine gara: {format(myTimestampToDate(cur_match.real_end), 'HH:mm')}</>}
                                <ButtonGroup>
                                    <Button variant={event_status?.cur_match?.id === cur_match?.id ? 'contained' : "outlined"} color={'success'} size="small" onClick={() => handlePlay(true)} startIcon={<PlayArrow />}></Button>
                                    <Button variant={event_status?.cur_match?.id === cur_match?.id ? 'contained' : "outlined"} color={'primary'} size="small" onClick={() => handlePlay()} startIcon={<Stop />}></Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>}
                    <Subheader />
                </Grid>
            </DialogTitle>
            <DialogContent ref={contentRef} sx={{ p: 0.5 }}>
                <Grid container>
                    {viewStatus === 'pre' ?
                        <Grid size={12}>
                            <PrematchCowlist
                                dynamic_cow_list={dynamic_cow_list}
                                linked_cow_list={linked_cow_list}
                                manual_cow_list={manual_cow_list}
                                cur_match={cur_match}
                                editFn={editFn}
                                not_completed={not_completed}
                                doSplit={doSplit}
                                handleShow={handleShow}
                                handleRemove={handleRemoveCow}
                                ABtn={(props) =>
                                    <ActionButton
                                        cowAction={updateCowParam}
                                        cow={props.cow}
                                        index={props.index}
                                        status={viewStatus}
                                        match_id={cur_match.id}
                                        insertMode={insertMode}
                                        viewMode={viewMode}
                                        duplicated_value={duplicated_value}
                                        cur_award={curAwardIndex}
                                    />

                                }

                            />
                        </Grid>
                        :
                        <>
                            <Grid size={5}>
                                <Box style={{ maxHeight: c_height, overflow: 'auto', borderRight: '1px solid grey' }}>

                                    {console.log("-----debug", cur_match)}
                                    {cur_match.cow_list.map((cow, k) => {
                                        if (viewStatus === 'pre' || cow.is_in_ring) {
                                            return <OneCow
                                                cow={cow}
                                                key={k}
                                                toggleSelect={toggleSelect}
                                                matchStatus={viewStatus}
                                                custom_filter={selEvent.custom_cow_filter_param_list}
                                                btn={
                                                    <Grid container size="grow">
                                                        <Grid size="grow">
                                                            <ActionButton
                                                                cow={cow}
                                                                index={k}
                                                                cowAction={updateCowParam}
                                                                postEdit={(v) => squalifyCow(cow, k, v)}
                                                                viewMode={viewMode}
                                                                status={viewStatus}
                                                                match_id={cur_match.id}
                                                                insertMode={insertMode}
                                                                duplicated_value={duplicated_value}
                                                                cur_award={curAwardIndex}
                                                            />
                                                        </Grid>
                                                        <Grid size={"auto"}>
                                                            <IconButton
                                                                tabIndex={-1} color="primary" size="small" variant="outlined" onClick={() => handleShow(cow)}><Info sx={{ fontSize: '1.2em' }} /></IconButton>
                                                        </Grid>
                                                    </Grid>

                                                }
                                                is_selected={selected_cow_id.indexOf(cow.id) >= 0} index={k}
                                            />
                                        } else {
                                            return (<></>)

                                        }
                                    }
                                    )}
                                </Box>
                            </Grid>
                        </>

                    }
                    {(viewStatus === 'run' || viewStatus === 'end') &&
                        award_list.length === 0 ?
                        <Grid container>
                            {cur_match.award_list && cur_match.award_list.length > 0 ?
                                <Button onClick={() => initAwardList()} color="warning" variant="contained"> inizializza lista premi</Button>
                                :
                                <Typography sx={globalstyles.missing_value}>
                                    Nessun premio definito
                                </Typography>
                            }
                        </Grid>
                        :
                        <Grid container size="grow" columnSpacing={2}>
                            {award_list.filter(f => viewMode === 'complete' || !f.from_other_data).map((a, ak) => (
                                <Grid size={"grow"} key={ak} >
                                    <Box style={{ maxHeight: c_height, overflow: 'auto' }}>
                                        {a.cow_list?.filter(cow => !cow.cow || !cow.cow?.squalified).map((cow, k) => (
                                            <OneResult
                                                cow={cow}
                                                key={k}
                                                toggleSelect={toggleSelect}
                                                point={a.point_list ? a.point_list[k] : undefined}
                                                updateCurIndex={() => updateCurIndex(ak, k)}
                                                cur_award={curAwardIndex[ak]}
                                                matchStatus={viewStatus}
                                                insertMode={insertMode}
                                                is_selected={selected_cow_id.indexOf(cow.id) >= 0} index={k}
                                                custom_filter={selEvent.custom_cow_filter_param_list?.map(f => f.param_name)}
                                                validateResult={() => validatePartialResult(a, getSelectedElement(cow.cow?.id, cur_match.cow_list, 'id'), award_list.filter(a => a.has_position)[0], cur_match.id)}
                                            />
                                        ))}
                                        {a.cow_list?.filter(cow => cow.cow?.squalified === true).map((cow, k) => (
                                            <OneResult
                                                cow={cow}
                                                key={k}
                                                toggleSelect={toggleSelect}
                                                updateCurIndex={() => updateCurIndex(ak, k)}
                                                cur_award={curAwardIndex[ak]}
                                                matchStatus={viewStatus}
                                                is_selected={selected_cow_id.indexOf(cow.id) >= 0} index={k}
                                                validateResult={() => console.log()}
                                                custom_filter={selEvent.custom_cow_filter_param_list?.map(f => f.param_name)}
                                            />
                                        ))}
                                        {viewStatus === 'run' && insertMode === 'button' && a.has_position &&
                                            <Button color="secondary" size="small" variant={curAwardIndex[ak]?.cur_id === -1 ? 'contained' : "outlined"} onClick={() => updateCurIndex(ak, -1)}>set 0</Button>
                                        }
                                        {/*                                             {viewStatus === 'run' && insertMode === 'text' &&
                                                <Tooltip title="valida risultati inseriti a mano"  >
                                                    <Button variant="contained" color="warning" disabled={duplicated_value.length > 0} size="small" onClick={() => confirmAward(a, ak)} startIcon={<Check />} >Convalida risultati</Button>
                                                </Tooltip>
                                            } */}
                                        {/*                                             {a.has_position &&
                                                <NotMatchCows match_cow_list={a.cow_list} cow_list={cur_match.cow_list} />
                                            } */}
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container flexDirection={"row"} sx={{ width: '100%' }}>
                    <Grid size={"grow"} sx={{ pr: 2 }}>
                        <Tooltip title="presenze prering">
                            <span>
                                <MultiColorProgressBar element_list={cur_match.cow_list} param='is_in_ring' />
                            </span>
                        </Tooltip>
                    </Grid>
                    <Grid size="auto">
                        <ButtonGroup>
                            <Button variant='outlined' key={'bc'} onClick={handleClose} startIcon={<Close />}>Chiudi</Button>
                            <Button variant='contained' color="warning" onClick={handlePdfDocs} startIcon={<PictureAsPdf />}>Documenti gare</Button>
                            {viewStatus === 'pre' &&
                                <>
                                    {isEdited &&
                                        <Button variant='contained' color="secondary" onClick={handleSave} startIcon={<Save />}>Salva presenze</Button>
                                    }
                                    {(cur_match.status === undefined || cur_match.status === 'pre') &&
                                        <>
                                            <Button variant={cur_match.cow_list?.length === 0 ? 'outlined' : 'contained'} color="success" onClick={() => handleStep('run')} endIcon={isEdited && <Save />} startIcon={<PlayArrow />}>Inizia gara ({cur_match.cow_list?.filter(c => c.is_in_ring)?.length} soggetti)</Button>

                                            {cur_match.cow_list?.length === 0 &&
                                                <>
                                                    {linked_cow_list.filter(c => c.is_present === true)?.length > 0 &&
                                                        <Button variant='contained' color="success" onClick={() => handleStep('prerun')} endIcon={isEdited && <Save />} startIcon={<PlayArrow />}>Conferma {linked_cow_list?.filter(c => c.is_present)?.length + manual_cow_list.length} soggetti ed inizia gara</Button>
                                                    }
                                                    {dynamic_cow_list?.length > 0 &&
                                                        <Button variant='contained' color={not_completed ? "warning" : "success"} onClick={() => handleStep('prerun')} startIcon={<PlayArrow />} endIcon={not_completed && <Warning />}>Conferma {dynamic_cow_list.length + manual_cow_list.length} soggetti ed inizia gara</Button>
                                                    }
                                                </>
                                            }
                                        </>
                                    }
                                </>
                            }
                            {viewStatus !== 'pre' &&
                                <Button variant='outlined' color="primary" onClick={showAwardList} startIcon={<List />}>risultati</Button>
                            }
                            {viewStatus === 'run' &&
                                <>
                                    {isEdited &&
                                        <>
                                            {matchStatus === 'run' ?
                                                <Button variant='contained' color="secondary" onClick={handleSave} startIcon={<Save />}>Salva risultati parziali</Button>
                                                :
                                                <Button variant='contained' color="secondary" onClick={handleSave} startIcon={<Save />}>Aggiorna dati gara</Button>
                                            }</>
                                    }
                                    {(cur_match.status === 'run') &&
                                        <Button variant='contained' color="error" onClick={() => handleStep('end')} startIcon={<Stop />} endIcon={isEdited && <Save />} >Termina gara</Button>
                                    }
                                </>
                            }
                            {viewStatus === 'end' && isEdited &&
                                <Button variant='contained' color="secondary" onClick={handleSave} startIcon={<Save />}>Salva modifiche ai risultati</Button>
                            }

                            {/*                             <Button onClick={() => testFn()}>TEST</Button> */}
                        </ButtonGroup>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>

    )

})




/* 
const CowlistErrorMessage = () => {
    return (
        <Typography sx={{ ...globalstyles.missing_value, textAlign: 'center' }}>
            Nessun soggetto ancora inserito in questa gara
        </Typography>
    )
}

const PreCowList = ({ viewStatus, selected_source_cow_id, linked_cow_list }) => {
    return (
        <>
            {
                linked_cow_list.map((cow, k) => (
                    <OneCow
                        cow={cow}
                        key={k}
                        index={k}
                        matchStatus={viewStatus}
                        //toggleSelect={handleAddCowList ? toggleSelectSource : undefined}
                        is_selected={selected_source_cow_id.indexOf(cow.id) >= 0}
                    />
                ))
            }
        </>
    )
}

const CowPrelist = () => {
    return (
        <>


        </>
    )
}

const NotMatchCows = ({ match_cow_list, cow_list }) => {
    const c_list = match_cow_list.map(c => c.cow?.id).filter(c => c !== undefined)
    const e_c_list = cow_list.filter(c => !c_list.includes(c.id))
    const viewStatus = 'end'
    if (e_c_list.length > 0) {
        return (
            e_c_list.map((cow, k) => (
                <OneResult
                    cow={{ cow: cow }}
                    index={-1}
                    key={k}
                    //                    cur_award={curAwardIndex[ak]}
                    matchStatus={viewStatus}
                />
            ))
        )
    }
}

 */
const RunHeader = ({ award_list, resetAward, ConfirmBtn, viewMode, squalifyCow, showUndo }) => {
    return (
        <Grid container flexDirection={"row"} spacing={1}>
            <Grid container flexDirection={"column"} size={5} >
                <Grid container sx={globalstyles.listHeader}>
                    <Grid size={1}>
                        Cat
                    </Grid>
                    <Grid size={3}>
                        Matr
                    </Grid>
                    <Grid size="grow" container>
                        {award_list?.filter(a => viewMode === 'complete' || !a.from_other_data).map((a, k) => (
                            <Grid key={k} size="grow" style={{ textAlign: 'center', fontSize: '10px' }}>
                                {a.award_name}
                            </Grid>
                        ))}
                    </Grid>
                    {showUndo !== undefined &&
                        <Grid size="auto">
                            <Button disabled={!showUndo} size="small" sx={{ ml: 2 }} onClick={() => squalifyCow(-1, -1, false)} variant={"contained"} color="error">
                                annulla squalifica
                            </Button>
                        </Grid>
                    }
                    <Grid size={0.3}>
                    </Grid>
                </Grid>
            </Grid>
            <>
                {award_list?.filter(a => viewMode === 'complete' || !a.from_other_data).map((a, k) => (
                    <Grid key={k} size={7 / award_list?.filter(a => viewMode === 'complete' || !a.from_other_data).length} sx={{ height: '38px', pl: 0 }} >
                        <Grid container sx={{ ...globalstyles.sectionHeader, pl: 0 }} size="grow">

                            <Grid size="grow" style={{ fontSize: '12px', textAlign: 'center' }}>
                                {a.award_name}
                            </Grid>

                            {!a.from_other_data && a.has_position &&
                                <Grid size={3}>
                                    <Tooltip title={`posizioni assegnate ${a.cow_list.filter(c => (c.cow && c.cow.id)).length}/${a.cow_list.length} `} arrow>
                                        <span>
                                            <MultiColorProgressBar element_list={a.cow_list.map(c => ({ position: c.cow?.id ? true : false }))} param='position' />
                                        </span>
                                    </Tooltip>
                                </Grid>
                            }

                            {a.has_position && ConfirmBtn &&
                                <Grid>
                                    <ConfirmBtn a={a} k={k} />
                                </Grid>
                            }

                            {!a.from_other_data && resetAward &&
                                <Grid size="auto" sx={{ pl: 1 }}>
                                    <Tooltip title={`resetta premi assegnati`} arrow>
                                        <Button color="error" size="small" style={{ padding: 0.5, minWidth: '10px', textAlign: "center" }} onClick={() => resetAward(a, k)} variant='contained'><Backspace style={{ fontSize: '12px' }} /></Button>
                                    </Tooltip>
                                </Grid>
                            }
                        </Grid>
                        <Grid container sx={{ ...globalstyles.listHeader, fontSize: '9px', marginRight: 0, paddingLeft: 0.5, paddingRight: 0 }} size="grow">
                            <Grid size={a.from_other_data ? 2 : "auto"}>
                                Pos
                            </Grid>
                            <Grid size={a.from_other_data ? 2 : "auto"}>
                                Cat
                            </Grid>
                            {!a.from_other_data &&
                                <Grid size={"grow"}>
                                    Matricola
                                </Grid>
                            }
                            {a.point_list && a.point_list.length > 0 &&

                                <Grid size={1}>
                                    pnt
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                ))}
            </>
        </Grid>
    )

}




const findOtherSameAward = (cow_list, award_id, position) => {
    return cow_list.findIndex(c => c.award_dict && c.award_dict[award_id] && c.award_dict[award_id].position === position)
}




const ActionButton = ({ cow, index, cowAction, status, cur_award, match_id, insertMode, duplicated_value, viewMode, postEdit }) => {


    const togglePresence = (v) => {
        cowAction(index, 'is_in_ring', v)
    }
    const assignAward = (award_index) => {
        cowAction(award_index, cow)
    }
    const setTextAward = (award_index, ev) => {
        try {
            const p = ev.target.value
            console.log(p)
            cowAction(award_index, cow, parseInt(p) - 1)
        } catch (err) {
        }
    }

    if (status === 'pre') {
        return (
            <PresenceButton is_present={cow.is_in_ring} togglePresence={togglePresence} label={"nel ring"} />
        )
    } else if (status === 'run') {
        if (insertMode === 'button') {
            return (
                <Grid container size={"grow"}>
                    {cur_award?.filter(f => viewMode === 'complete' || !f.from_other_data).map((a, k) => {
                        let c = ''
                        if (cur_award[k].from_other_data) {
                            if (cow[cur_award[k].award_value]) {
                                c = <Typography sx={{ fontSize: '10px', textAlign: 'center', paddingRight: 1 }}>
                                    {cow[cur_award[k].award_value]}
                                </Typography>
                            }
                        } else {
                            c = <><Button fullWidth size="small" key={k} style={{ padding: 2, minWidth: '10px' }} onClick={() => assignAward(k, cow)} variant={cow.award_dict && cow.award_dict[match_id + "_" + a.id] && cow.award_dict[match_id + "_" + a.id].position === cur_award[k].cur_id ? 'contained' : 'outlined'} color="warning">
                                <Typography style={{ textTransform: 'none', fontSize: '10px' }}>
                                    Assegna {cur_award[k].has_position ? <b>{cur_award[k].cur_id + 1}</b> : ""}
                                </Typography>
                            </Button>
                            </>
                        }

                        console.log(cow, match_id + "_" + a.id, c)
                        if (cow.award_dict && cow.award_dict[match_id + "_" + a.id] !== undefined) {
                            return (
                                <Grid key={k} size="grow" style={{ textAlign: "center" }}>
                                    <SideBadge showZero color={cow.award_dict[match_id + "_" + a.id].position === -1 ? "secondary" : "primary"} badgeContent={cow.award_dict[match_id + "_" + a.id].position + 1}>
                                        {c}
                                    </SideBadge>
                                </Grid>
                            )
                        } else {
                            return (
                                <Grid key={k} size="grow">
                                    {c}
                                </Grid>
                            )

                        }
                    }
                    )}
                </Grid>
            )
        } else {
            return (
                <>
                    <Grid container size={11}>

                        {cur_award?.filter(f => viewMode === 'complete' || !f.from_other_data).map((a, k) => {

                            if (a.has_position) {
                                let award_status = undefined
                                let infoLabel = undefined
                                let startIcon = <Error fontSize='1.5em' />
                                if (cow.award_dict && cow.award_dict[match_id + "_" + a.id] && cow.award_dict[match_id + "_" + a.id].position !== undefined && !isNaN(cow.award_dict[match_id + "_" + a.id].position)) {
                                    if (cow.award_dict[match_id + "_" + a.id].position === -1) {
                                        award_status = 'out'
                                        startIcon = <Block color="primary" fontSize='1.5em' />
                                        infoLabel = <Typography sx={{ fontSize: '0.7em' }}>N.C.</Typography>
                                    } else if (duplicated_value.includes(match_id + "_" + a.id + "_" + cow.award_dict[match_id + "_" + a.id].position)) {
                                        console.log("DUPLICATE")
                                        startIcon = <Error color='error' fontSize='1.5em' />
                                        award_status = 'duplicate'
                                        infoLabel = <Typography sx={{ fontSize: '0.7em', color: 'red' }}>duplicato</Typography>
                                    } else if (cow.award_dict[match_id + "_" + a.id].position > a.max_position - 1) {
                                        startIcon = <Error color='error' fontSize='1.5em' />
                                        award_status = 'duplicate'
                                        infoLabel = <Typography sx={{ fontSize: '0.7em', color: 'red' }}>fuori range</Typography>
                                    } else {
                                        startIcon = <Check color="success" fontSize='1.5em' />
                                    }

                                }

                                /*                                 if (cow.award_dict && cow.award_dict[match_id + "_" + a.id] && cow.award_dict[match_id + "_" + a.id].position !== undefined) {
                                                                    has_duplicate = duplicated_value.includes(match_id + "_" + a.id + "_" + cow.award_dict[match_id + "_" + a.id].position)
                                                                } */
                                const value = cow.award_dict && cow.award_dict[match_id + "_" + a.id] && cow.award_dict[match_id + "_" + a.id].position + 1
                                return (
                                    <Grid key={k} size="grow">
                                        <Input
                                            autoComplete='off'
                                            size="small"
                                            variant="outlined"
                                            value={isNaN(value) ? '' : value}
                                            onChange={(v) => setTextAward(k, v)}
                                            sx={{ width: '100%', ml: 1 }}
                                            status={award_status}
                                            error={award_status === 'duplicate'}
                                            endAdornment={infoLabel}
                                            startAdornment={startIcon}
                                        />
                                    </Grid>
                                )
                            } else {
                                let c = ''
                                if (cur_award[k].from_other_data) {
                                    c = <Typography sx={{ fontSize: '10px', textAlign: 'center', paddingRight: 1, }}>
                                        {cow[cur_award[k].award_value]}
                                    </Typography>

                                } else {
                                    c = <Button size="small" key={k} style={{ padding: 2, minWidth: '10px' }} onClick={() => assignAward(k, cow)} variant={cow.award_dict && cow.award_dict[match_id + "_" + a.id] && cow.award_dict[match_id + "_" + a.id].position === cur_award[k].cur_id ? 'contained' : 'outlined'} color="warning">
                                        <Typography style={{ textTransform: 'none', fontSize: '10px' }}>
                                            Assegna {cur_award[k].has_position ? <b>{cur_award[k].cur_id + 1}</b> : ""}
                                        </Typography>
                                    </Button>
                                }
                                if (cow.award_dict && cow.award_dict[match_id + "_" + a.id] !== undefined && !isNaN(cow.award_dict[match_id + "_" + a.id].position)) {
                                    return (
                                        <Grid key={k} size="grow" style={{ textAlign: "center" }}>
                                            <SideBadge color="secondary" badgeContent={cow.award_dict[match_id + "_" + a.id].position + 1}>
                                                {c}
                                            </SideBadge>
                                        </Grid>
                                    )
                                } else {
                                    return (
                                        <Grid key={k} size="grow" style={{ textAlign: "center" }}>
                                            {c}
                                        </Grid>
                                    )
                                }
                            }

                        }
                        )}
                    </Grid>
                </>
            )

        }
    } else if (status === 'end') {
        return (
            <>
                <Grid container size={"grow"}>
                    {cur_award?.filter(f => viewMode === 'complete' || !f.from_other_data).map((a, k) => {
                        if (cow.award_dict && cow.award_dict[match_id + "_" + a.id] !== undefined) {
                            if (cur_award[k].from_other_data) {
                                //console.log(cow.award_dict[match_id + "_" + a.id].award_name, cow.award_dict[match_id + "_" + a.id].position)
                                if (cow.award_dict[match_id + "_" + a.id].position >= 0) {
                                    return (
                                        <Grid key={k} size="grow" style={{ textAlign: "center", }}>
                                            <MilitaryTech />
                                        </Grid>
                                    )

                                } else {
                                    return <Grid size="grow"></Grid>
                                }
                            } else {
                                if (cur_award[k].has_position) {
                                    return (
                                        <Grid size="grow" key={k} style={{ textAlign: "center" }}>
                                            <MyBadge color="green" key={k} label={cow.award_dict[match_id + "_" + a.id].position + 1} />
                                        </Grid>
                                    )

                                } else {
                                    return (
                                        <Grid key={k} size="grow" style={{ textAlign: "center" }}>
                                            <MilitaryTech style={{ color: 'orange' }} />
                                        </Grid>
                                    )

                                }
                            }
                        } else {
                            return <Grid key={k} size="grow"></Grid>

                        }
                    }
                    )}
                    <Grid size="grow" sx={{ textAlign: 'right' }}>
                        <ButtonGroup>

                            <Button size="small" sx={{ ml: 2 }} onClick={() => postEdit(true)} variant={cow.squalified === true ? 'contained' : 'outlined'} color="error">
                                squalifica
                            </Button>
                        </ButtonGroup>
                    </Grid>
                </Grid>
            </>
        )

    }
}

const OneResult = ({ index, cow, updateCurIndex, cur_award, matchStatus, insertMode, point, validateResult, custom_filter }) => {
    const disabled = cur_award.from_other_data && !validateResult()
    const getChipColor = () => {
        if (matchStatus === 'run') {
            if (!disabled) {
                return 'purple'
                return 'secondary'
            }
        } else {
            if (cow.cow?.squalified) {
                return 'orange'
            }
            if (cow.position_id < 0) {
                return 'lightblue'
                return 'primary'
            }
            if (!disabled) {
                return 'purple'
                return 'secondary'
            }
        }
        return 'grey'
    }
    return (

        <Grid container sx={{ ...globalstyles.list_row, fontSize: '0.7em', backgroundColor: cow.cow?.squalified === true ? 'red' : '', color: disabled ? 'lightgrey' : 'black' }}>
            {matchStatus === 'run' ?
                <Grid size={1.8} flexDirection={"row"} container>
                    {cur_award.has_position ?
                        <>
                            {insertMode === 'button' ?
                                <Button size="small" variant={cur_award?.cur_id === index ? 'contained' : "outlined"} onClick={() => updateCurIndex(cur_award?.id, index)} style={{ minWidth: '10px', padding: 3 }}>
                                    <Typography sx={{ textTransform: 'none', fontSize: 10, lineHeight: 1.2, }}>
                                        set <br /><b>{index + 1}</b>
                                    </Typography>
                                </Button>
                                : <Grid size={"grow"}>
                                    <Chip label={cow.position_id + 1} size="small" />
                                </Grid>
                            }
                        </>
                        :
                        <>
                            {cur_award.from_other_data ? <>
                                <MyBadge color={getChipColor()} label={cow.position_id + 1} />

                            </>
                                :
                                <MilitaryTech style={{ fontSize: '14px' }} />
                            }
                        </>
                    }
                </Grid>
                :
                <Grid size={1.3}>
                    <MyBadge color={getChipColor()} label={
                        cow.cow?.squalified ? cow.original_position_id + 1 : index + 1}
                    />
                </Grid>
            }
            <Grid size={2} style={{ fontWeight: 'bold' }}>
                {cow.cow?.catalog_id}
            </Grid>

            {cur_award.from_other_data === true ?
                <Grid size="grow" style={{ textAlign: "center" }}>
                    {cow.cow && cow.cow[cur_award.award_value] ?
                        <> ({cow.cow[cur_award.award_value]})</>
                        : <></>
                    }
                </Grid>
                :
                <Grid size="grow" flexDirection={"row"} container>
                    <CowtypeBadge cow_type={cow.cow?.cow_type} />
                    {cow.cow?.serial}
                    <Box>
                        {custom_filter?.filter(cf => cow.cow && cow.cow[cf] === true).map((cf, k) => (
                            <MyBadge as="span" size="small" color="lightblue" label={cf} key={k} />
                        ))}
                    </Box>
                </Grid>
            }

            <Grid size="auto" style={{ color: 'blue' }}>
                {point}
            </Grid>
        </Grid>
    )
}

const OneCow = memo(({ cow, btn, showSelect, matchStatus, toggleSelect, is_selected, custom_filter }) => {

    return (
        <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.7em' }}>
            {toggleSelect && showSelect && matchStatus === 'pre' &&
                <Grid size={1}>
                    <Button variant={is_selected ? 'contained' : 'outlined'} onClick={() => toggleSelect(cow.id)} size="small" >{is_selected ? <CheckBox /> : <CheckBoxOutlineBlank />}</Button>
                </Grid>
            }
            <Grid size={1} sx={{ paddingLeft: 1, fontWeight: 'bold' }}>
                {cow.catalog_id}
            </Grid>
            <Grid size={matchStatus === 'run' || matchStatus === 'end' ? 3 : 0.5} flexDirection={"row"} container >
                <CowtypeBadge cow_type={cow.cow_type} />
                {cow.serial}&nbsp;
                <Box>

                    {custom_filter?.filter(cf => cow[cf.param_name] === true).map((cf, k) => (
                        <MyBadge as="span" size="small" color="lightblue" label={cf.param_name} key={k} />
                    ))}
                </Box>
            </Grid>
            <Grid size="grow">
                {btn}
            </Grid>
        </Grid>
    )
})


const validatePartialResult = (cur_award, cow, award_position, match_id) => {
    if (award_position) {
        if (cur_award.from_other_data && cur_award.limit_count && parseInt(cur_award.limit_count) !== 0) {
            //console.log("CHECK COW POSITION", cur_award.limit_count, match_id + "_" + cur_award.id, cow, cow.award_dict? cow.award_dict[match_id + "_" + cur_award.id]: cow.award_dict)
            //console.log("CHECK COW", cow)
            if (cow.award_dict && cow.award_dict[match_id + "_" + award_position.id] && cow[cur_award.award_value] &&
                cow.award_dict[match_id + "_" + award_position.id].position < parseInt(cur_award.limit_count)) {
                return true
            }
            return false
        } else {
            return true

        }

    } else {
        return true
    }
}



const validateFinalResult = (match, award_list, doInitAuto) => {
    console.log("VALIDATE FINAL RESULT", match, award_list)
    let aw_match_real = {}
    const aw_positioning = award_list.filter(a => a.has_position)[0]
    console.log("\tMATCH COW LIST", match.cow_list)
    if (match.award_list.filter(a => a.from_other_data).length > 0) {
        for (const c_aw of award_list.filter(a => a.from_other_data)) {
            let l = c_aw.cow_list?.filter(c => {
                //console.log("check cow", c_aw.award_name, c, aw_positioning, match.id, getSelectedElement(c.cow?.id, match.cow_list, 'id').catalog_id)
                const validate = validatePartialResult(c_aw, getSelectedElement(c.cow?.id, match.cow_list, 'id'), aw_positioning, match.id)
                console.log("check cow", c_aw.award_name, c.position_id, getSelectedElement(c.cow?.id, match.cow_list, 'id').catalog_id, validate, c.cow?.squalified ? 'squalified' : '')
                return validate
            })
            if (!c_aw.has_position) {
                console.log(match.id + "_" + c_aw.id)
                aw_match_real[match.id + "_" + c_aw.id] = l.map((c, k) => {
                    if (k === 0) {
                        return c
                    } else {
                        return {}
                    }
                })
            } else {
                aw_match_real[match.id + "_" + c_aw.id] = l
            }
        }
    } else {
        return match
    }
    const cl = match.cow_list.map(c => {
        let _award_dict = { ...c.award_dict }
        console.log("COW", _award_dict)
        if (true) {
            for (const aw of award_list.filter(a => a.from_other_data)) {
                const aw_id = match.id + "_" + aw.id
                console.log(aw.award_name, aw_id, aw.cow_list)
                if (!_award_dict[aw_id]) {
                    const pos = aw.cow_list.map(cc => cc.cow?.id).indexOf(c.id)
                    //console.log("INIT pos", aw.cow_list[pos], pos,) //aw.cow_list[pos].position_id >= 0)
                    _award_dict[aw_id] = {
                        position: aw.cow_list[pos] && aw.cow_list[pos].position_id >= 0 ? pos : -1,
                        award_name: aw.award_name,
                        match_name: match.match_name
                    }
                }
            }
        }
        for (const aw_id in aw_match_real) {
            console.log(_award_dict, aw_id)
            const aw = aw_match_real[aw_id]
            if (_award_dict[aw_id]) {
                console.log("SET REAL POSITION", _award_dict[aw_id], aw_match_real[aw_id].map(c => c.cow?.id).indexOf(c.id))
                _award_dict[aw_id].old_position = _award_dict[aw_id].old_position || _award_dict[aw_id]?.position
                _award_dict[aw_id].position = aw_match_real[aw_id].map(c => c.cow?.id).indexOf(c.id)
            }
        }
        return { ...c, award_dict: _award_dict }
    })
    return { ...match, cow_list: cl }

}